import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AllocatedConfigurationDetail } from '../models/AllocatedConfigurationDetail';
import { BookingStatus } from 'src/modules/models/booking-status/booking-status';

@Injectable({
  providedIn: 'root'
})
export class AllocatedConfigurationDetailService {

  constructor() { }

  allocatedConfigurationDetails$ = new BehaviorSubject<AllocatedConfigurationDetail[]>([]);
  selectedBookingStatus$ = new BehaviorSubject<BookingStatus>(undefined);
  isRemovedSelectedSeat$ = new BehaviorSubject<boolean>(false);
  selectedSeat$ = new BehaviorSubject<number>(null);
  deSelectedSeat$ = new BehaviorSubject<number>(null);
  selectedBookingSeat$ = new BehaviorSubject<number[]>(null);
  deSelectedBookingSeat$ = new BehaviorSubject<number[]>(null);
  showingBookingSeat$ = new BehaviorSubject<number[]>(null);
  allSeatsHighlighted$ = new BehaviorSubject<boolean>(false);

  private allocationSeatIds = new BehaviorSubject<string[]>([]); 
  allocationSeatIds$ = this.allocationSeatIds.asObservable();

  private clearSeatSelection = new BehaviorSubject<boolean>(false);
  clearSeatSelection$ = this.clearSeatSelection.asObservable();

  private clearBookingSelection = new BehaviorSubject<boolean>(false);
  clearBookingSelection$ = this.clearBookingSelection.asObservable();

  private clearNotAvailableSeatSelection = new BehaviorSubject<boolean>(false);
  clearNotAvailableSeatSelection$ = this.clearNotAvailableSeatSelection.asObservable();

  private selectedSeats = new BehaviorSubject<number[]>([]);
  selectedSeats$ = this.selectedSeats.asObservable();

  private selectedSeatID = new BehaviorSubject<string>(null);
  selectedSeatId = this.selectedSeatID.asObservable();

  private undoActionSubject = new BehaviorSubject<boolean>(false);
  undoAction$ = this.undoActionSubject.asObservable();

  setValue(configurationDetails: AllocatedConfigurationDetail[]) {
    this.allocatedConfigurationDetails$.next(configurationDetails);
  }

  getValue() {
    return this.allocatedConfigurationDetails$.asObservable();
  }
  //To transfer the selected seat from the Booking Function Directive to the Booking List Component.
  getSelectedSeatValue() {
    return this.selectedSeat$.asObservable();
  }

  //To transfer the selected seats of the booking, when seats are selected from the Venue Map, from the Booking List Component to the Booking Function Directive.
  getShowingBookingSeat() {
    return this.showingBookingSeat$.asObservable();
  }

  //To transfer the de selected seat from the Booking Function Directive to the Booking List Component;
  getDeSelectedSeatValue() {
    return this.deSelectedSeat$.asObservable();
  }

  //When a booking is selected from the list, the booking seats need to be transferred from the Booking List Component to the Booking Function Directive.
  getSelectedBookingSeatValue() {
    return this.selectedBookingSeat$.asObservable();
  }

  //When a booking is deselected from the list, the booking seats need to be transferred from the Booking List Component to the Booking Function Directive.
  getDeSelectedBookingSeatValue() {
    return this.deSelectedBookingSeat$.asObservable();
  }

  resetValues() {
    this.allocatedConfigurationDetails$.next([]);
    this.selectedBookingStatus$.next(undefined);
    this.isRemovedSelectedSeat$.next(false);
  }

  setSelectedBookingStatusValue(status : BookingStatus) {
    this.selectedBookingStatus$.next(status);
  }

  getSelectedBookingStatusValue() {
    return this.selectedBookingStatus$.asObservable();
  }

  addAllocationSeatIds(seatIds: string[]) {
    this.allocationSeatIds.next(seatIds);
  }

  clearNotAvailableSeats(value) {
    this.clearNotAvailableSeatSelection.next(value);
  }
  
  clearSeatSelections() {
    this.clearSeatSelection.next(true);
  }

  clearBookingSelections() {
    this.clearBookingSelection.next(true);
  }

  setIsRemovedSelectedSeatValue(val : boolean) {
    this.isRemovedSelectedSeat$.next(val);
  }

  getIsRemovedSelectedSeatValue() {
    return this.isRemovedSelectedSeat$.asObservable();
  }

  addAvailableSeat(seatId: number) {
    const currentSeats = this.selectedSeats.getValue();
    if (!currentSeats.includes(seatId)) {
      this.selectedSeats.next([...currentSeats, seatId]);
    }
  }

  removeAvailableSeat(seatId: number) {
    const currentSeats = this.selectedSeats.getValue();
    const updatedSeats = currentSeats.filter(seat => seat !== seatId);
    this.selectedSeats.next(updatedSeats);
  }

  clearSeats() {
    this.selectedSeats.next([]);
  }

  getSelectedSeats(seatId: string) {
    this.selectedSeatID.next(seatId);
  }

  triggerUndoAction() {
    this.undoActionSubject.next(true);
  }
  
  resetUndoAction() {
    this.undoActionSubject.next(false);
  }

}
